import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/consumer/Link';
const ToolbarLinkOrButton = t0 => {
  const $ = _c(8);
  let otherProps;
  let to;
  if ($[0] !== t0) {
    ({
      to,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = to;
  } else {
    otherProps = $[1];
    to = $[2];
  }
  if (to) {
    let t1;
    if ($[3] !== otherProps || $[4] !== to) {
      t1 = <Link to={to} {...otherProps} />;
      $[3] = otherProps;
      $[4] = to;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  let t1;
  if ($[6] !== otherProps) {
    t1 = <button {...otherProps} type="button" />;
    $[6] = otherProps;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
ToolbarLinkOrButton.propTypes = {
  to: PropTypes.string
};
export default ToolbarLinkOrButton;